function getIpfsHash(url) {
    return url.replace('ipfs://', '');
}

export default getIpfsHash;